import { Alert, Button, Stack, Typography } from "@mui/material";

import React from "react";
import { useTranslation } from "react-i18next";

export type SignedFlowTimerAlertProps = {
  remainingFormatted: string | null;
  timerExpired: boolean;
  onRestart: () => void;
};

/**
 * Timer and timeout info for signed flow: remaining time or session expired (with restart).
 * Use alongside SignedFlowErrorAlert for error messages.
 */
export const SignedFlowTimerAlert: React.FC<SignedFlowTimerAlertProps> = ({
  remainingFormatted,
  timerExpired,
  onRestart,
}) => {
  const { t } = useTranslation();

  if (remainingFormatted != null) {
    return (
      <Alert severity="info">
        <Stack spacing={0.5}>
          <Typography variant="subtitle2" component="p" fontWeight="bold">
            {t("signedFlow.timeRemaining", { time: remainingFormatted })}
          </Typography>
          <Typography variant="body2" component="p">
            {t("signedFlow.timerExplanation")}
          </Typography>
        </Stack>
      </Alert>
    );
  }

  if (timerExpired) {
    return (
      <Alert severity="warning">
        <Stack spacing={1.5}>
          <Typography variant="subtitle2" component="p" fontWeight="bold">
            {t("signedFlow.timerExpiredTitle")}
          </Typography>
          <Typography variant="body2" component="p">
            {t("signedFlow.timerExpiredMessage")}
          </Typography>
          <Stack direction="row" justifyContent="flex-end">
            <Button
              variant="contained"
              color="warning"
              size="small"
              onClick={onRestart}
              sx={{ whiteSpace: "nowrap" }}
            >
              {t("signedFlow.restartShort")}
            </Button>
          </Stack>
        </Stack>
      </Alert>
    );
  }

  return null;
};
